type SubLocales = Record<string, string>;

type Locales = Record<string, SubLocales | string>;

/**
 * 合并语言包单文件
 * 注意：合并将在不破坏fixedLs的前提下进行，mergedLs中有破坏性的部分将被放弃
 */
const mergeTwo: any = (fixedLs: Locales, mergedLs: Locales) =>
    Object.entries(mergedLs).reduce(
        (prev: Locales, [key, value]: any) =>
            prev[key]
                ? typeof prev[key] === 'object' && typeof value === 'object'
                    ? {
                          ...prev,
                          [key]: mergeTwo(prev[key] as Locales, value),
                      }
                    : prev
                : {
                      ...prev,
                      [key]: value,
                  },
        fixedLs,
    );

const merge = (...sources: Locales[]) => sources.reduce((prev, curr) => mergeTwo(prev, curr), {});

export default merge;
